/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import sanitize from 'sanitize-html';
import { NOTIFICATION_TYPE } from '../constants/notification';
import { acknowledgeNotificationRequest } from '../store/actions/notification.action';
import Notification from './Notification';

type Props = {
  unseenNotifications: () => mixed;
  acknowledgeNotificationRequest: () => mixed;
};

/**
 * Displays the Notification in the form of a card.
 */
class NotificationViewer extends React.Component<Props> {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
      currentNotification: 0,
    };
  }

  onFinalClick = () => {
    this.props.acknowledgeNotificationRequest({
      notificationIds: this.getAllPreviousIds(this.state.currentNotification),
    });
    this.setState({
      isChecked: false,
      currentNotification: 0,
    });
    // The terms and conditions notification has 1 in the first entry of the list returned by getAllPreviousIds
  };

  onPrevClick = () =>
    this.setState((prevState) => ({ currentNotification: prevState.currentNotification - 1 }));

  onNextClick = () =>
    this.setState((prevState) => ({ currentNotification: prevState.currentNotification + 1 }));

  onCheckboxChange = () => this.setState((prevState) => ({ isChecked: !prevState.isChecked }));

  getNotification = (i) => {
    if (!this.props.unseenNotifications) {
      return undefined;
    }
    return this.props.unseenNotifications[i];
  };

  getText = (i) => {
    let ret = '';
    ret += this.getNotification(i)?.title?.Valid
      ? `<h1>${this.getNotification(i)?.title.String}</h1>`
      : '';
    ret += this.getNotification(i)?.text?.Valid ? this.getNotification(i)?.text.String : '';
    return ret;
  };

  getAllPreviousIds = (i) => {
    return this.props.unseenNotifications.slice(0, i + 1).map((x) => x.id);
  };

  notificationType = (i) => {
    if (this.getNotification(i)?.requires_ack) return NOTIFICATION_TYPE.ACK;
    if (this.props.unseenNotifications?.length === 1) return NOTIFICATION_TYPE.SINGLE;
    if (i === 0) return NOTIFICATION_TYPE.FIRST;
    if (i < this.props.unseenNotifications?.length - 1) return NOTIFICATION_TYPE.MID;
    return NOTIFICATION_TYPE.FINAL;
  };

  render() {
    const { currentNotification } = this.state;
    const sanitizedContent = sanitize(this.getText(currentNotification), {
      allowedTags: [
        'h1',
        'h2',
        'p',
        'br',
        'ol',
        'li',
        'ul',
        'strong',
        'style',
        'span',
        'html',
        'head',
        'meta',
        'body',
        'img',
        'iframe',
      ],
      allowedAttributes: false,
      allowVulnerableTags: true,
    });

    // TODO: fix flash that occurs after final notification
    return (
      <>
        {this.props.unseenNotifications?.length > 0 && (
          <Notification
            content={sanitizedContent}
            isChecked={this.state.isChecked}
            notificationType={this.notificationType(currentNotification)}
            onCheckboxChange={this.onCheckboxChange}
            onPrevClick={this.onPrevClick}
            onNextClick={this.onNextClick}
            onFinalClick={this.onFinalClick}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  unseenNotifications: state.notification.unseenNotifications,
});

export default connect(mapStateToProps, {
  acknowledgeNotificationRequest,
})(NotificationViewer);
